<template>
    <div>
        <div class="banner-panel">
            <img src="../../assets/join-banner.png" />
        </div>
        <div class="join-panel">
            <div class="title">加入我们，成为耘径社区合伙人</div>
            <div class="content-panel">
                <span class="icon"><van-icon name="success" /></span>
                <span>距杭州城区30分钟车程的自营农场</span>
            </div>
            <div class="content-panel">
                <span class="icon"><van-icon name="success" /></span>
                <span>360天,不间断产出新鲜果蔬供采摘</span>
            </div>
            <div class="content-panel">
                <span class="icon"><van-icon name="success" /></span>
                <span>社区合伙人自购享折扣,分享赚佣金</span>
            </div>
        </div>

        <div class="button-panel">
            <van-button :disabled="join_button_disabled" class="button" type="primary" :url="auth_url">立即加入</van-button>
            <div class="agree-panel">
                <van-checkbox checked-color="#07c160" v-model="agree_check" @change="checked_change">我同意《耘径联盟用户协议》《隐私政策》《法律声明》</van-checkbox>
            </div>
        </div>
<!--        <div>{{auth_url}}</div>-->
<!--        <div>返回的code值：{{weixin_code}}</div>-->
    </div>
</template>

<script>
    import { mapActions } from 'vuex';
    import config from '@/config';
    import store from '@/store';

    export default {
        name: "Join",
        data(){
            return{
                auth_url:'',
                weixin_code:this.$route.query.code,         //query：获取url中get模式参数
                weixin_state:this.$route.query.state,
                agree_check:false,
                join_button_disabled:true
            }
        },
        methods:{
            ...mapActions([
                'WeixinLogin',
            ]),
            get_auth_url(){
                // let redirect_uri=encodeURIComponent(config.weixin.redirect_dev);
                let redirect_uri = encodeURIComponent(window.location.href);
                let appid=config.weixin.appid_yj;
                let state='join';
                this.auth_url=  'https://open.weixin.qq.com/connect/oauth2/authorize?' +
                    'appid=' +appid+
                    '&redirect_uri=' +redirect_uri+
                    '&response_type=code&scope=snsapi_userinfo&' +
                    'state=' +state+
                    '#wechat_redirect';
            },
            checked_change(val){
                this.join_button_disabled = !val;
            }
        },
        mounted() {
            let loginUser = store.getters.getLoginUser;
            // console.log(loginUser.id);
            let that=this;
            if(loginUser&&loginUser.openid){
                this.$Dialog.alert({message:'您已是注册会员了哦~'}).then(()=>{
                    that.$router.push({name:'home'});
                });
            }else{
                this.get_auth_url();
                if(this.weixin_code){
                    // console.log('----- 开始调用后台微信登录接口 ------');
                    this.WeixinLogin({code:this.weixin_code,mode:2}).then(res=>{
                        // console.log('返回对象',res);
                        if(res.status>0){
                            //失败
                            this.$toast.fail(res.msg);
                        }else{
                            //成功，直接返回列表
                            this.$toast.success('欢迎加入耘径联盟！');
                            this.$router.push({name:'home'});
                        }
                    });
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .banner-panel{
        img{
            width: 100%;
        }
    }
    .button-panel{
        text-align: center;
        padding-top: 50px;
        .button{
            width: 80%;
            border-radius: 20px;
        }
        .agree-panel{
            display: inline-block;
            text-align: center;
            font-size: 10px;
            color: #666666;
            padding-top: 14px;
        }
    }
    .join-panel{
        padding-top: 10px;
        color: #333333;
        .title{
            font-size: 16px;
        }
        .content-panel{
            padding: 5px;
            .icon{
                font-size: 14px;
            }
            span{
                font-size: 12px;
                padding-left: 5px;
            }
        }
    }

</style>